export default {
    excess: 'Omavastuu',
    security: 'Katevarmenne',
    fuel_policy: 'Polttoainekäytäntö',
    like_for_like: 'Vastaavasta vastaavaan',
    full_to_full: 'Täysi',
    mileage: 'Ajokilometrit: {mileage} vuokrausta kohden',
    unlimited_mileage: 'Vapaat kilometrit',
    non_refundable: 'Peruutukset: Ei Hyvitettävissä',
    free_cancellation_until: 'Maksuton peruutus päättyy: {date}',
    cancellation_with_terms: 'Peruutus {0} noudattaa ',
    t_c_text: 'Varausehtoja',
    two_free_extras: 'Kaksi ilmaista lisävarustetta noudattaessa',
    glass_tyres_covered: 'Tuulilasi ja renkaat katetaan'
}
